/** @format */

import {styled} from '@mui/material/styles';
import {Box} from '@mui/material';

export const SegmentedBox = styled(Box)(() => ({
  width: 'max-content',
  borderRadius: '8px',
  overflow: 'hidden',
  display: 'flex',
  gap: '1px',
}));
